import { SimplifiedSingleNews } from "../../../types/news"
import React from "react"
import { removeLinkRelNoopenerNoreferrer } from "../../../utils/urls"
import PredictionQuotes from "@components/Predictions/PredictionQuotes"

export const NewsContent = ({ news, trigger }: { news: SimplifiedSingleNews; trigger?: string | null }) => {
  const triggerSplit = news.content.replace(/\n/g, "<br/>").split(`${trigger}`)
  return triggerSplit.length >= 2 ? (
    <>
      <div
        className={"news-content-div"}
        style={{ marginTop: "20px", whiteSpace: "pre-line", fontSize: "16px" }}
        dangerouslySetInnerHTML={{ __html: removeLinkRelNoopenerNoreferrer(triggerSplit[0]) }}
      />
      {trigger === "triggerIframeQuote" && (
        <div>
          <PredictionQuotes col={6} news={news} />
        </div>
      )}
      <div
        className={"news-content-div"}
        style={{ marginTop: "20px", whiteSpace: "pre-line", fontSize: "16px" }}
        dangerouslySetInnerHTML={{ __html: removeLinkRelNoopenerNoreferrer(triggerSplit[1]) }}
      />{" "}
    </>
  ) : (
    <div
      className={"news-content-div"}
      style={{ marginTop: "20px", whiteSpace: "pre-line", fontSize: "16px" }}
      dangerouslySetInnerHTML={{ __html: removeLinkRelNoopenerNoreferrer(triggerSplit[0]) }}
    />
  )
}
